import { checkFollowProject } from "@/api/endpoint/project/check-follow-project";
import { ProjectContext } from "@/context/project.context";
import { useAuth } from "@/hooks/useAuth";
import clsx from "clsx";
import dynamic from "next/dynamic";
import { useCallback, useContext, useEffect, useState } from "react";
import HeaderDetail from "./HeaderDetail";
import HeaderProjectInfo from "./HeaderProjectInfo";
import HeaderProjectScroll from "./HeaderProjectScroll";
import ReviewFilter from "./ReviewFilter";
import RightContent from "./RightContent/RightContent";

const ListReview = dynamic(
  import("@/modules/common/ProjectDetail/ListReview"),
  { ssr: false }
);

const ProjectDetail = () => {
  const {
    project,
    checkFollowProject: dataFollowProject,
    setCheckFollowProject,
  } = useContext(ProjectContext);

  const { token } = useAuth();
  const [isShowScrolHeader, setIsShowScrollHeader] = useState(false);
  const handleScroll = () => {
    const position = window.scrollY;
    setIsShowScrollHeader(position > 468);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleCheckFollowProject = useCallback(async () => {
    const res = await checkFollowProject({ project: project?._id }, token);
    if (res?.results) {
      setCheckFollowProject(true);
    } else {
      setCheckFollowProject(false);
    }
  }, [project?._id, setCheckFollowProject, token]);
  useEffect(() => {
    if (token) {
      handleCheckFollowProject();
    }
  }, [handleCheckFollowProject, token]);

  return (
    <div className="wrap-home bg-grey-50 min-h-screen">
      <HeaderDetail />
      <div
        className={clsx(
          "home-tabs ",
          isShowScrolHeader
            ? "fixed w-full top-14 z-20 h-fit"
            : "layout h-[459px]"
        )}>
        {isShowScrolHeader ? (
          <HeaderProjectScroll
            project={project}
            isFollowProject={dataFollowProject}
          />
        ) : (
          <HeaderProjectInfo
            project={project}
            isFollowProject={dataFollowProject}
          />
        )}
      </div>
      <div
        className={clsx(
          "layout pb-6 ",
          isShowScrolHeader ? "!pt-[37rem]" : ""
        )}>
        <div className="flex gap-6 pt-10 w-full overflow-auto">
          <ListReview reviewFilter={<ReviewFilter />} />
          <RightContent project={project} />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;
